import { render, staticRenderFns } from "./RevenuePerMonthCompareSettings.vue?vue&type=template&id=932118d8&scoped=true"
import script from "./RevenuePerMonthCompareSettings.vue?vue&type=script&lang=ts"
export * from "./RevenuePerMonthCompareSettings.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "932118d8",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/winfakt/wf/v2.online.dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('932118d8')) {
      api.createRecord('932118d8', component.options)
    } else {
      api.reload('932118d8', component.options)
    }
    module.hot.accept("./RevenuePerMonthCompareSettings.vue?vue&type=template&id=932118d8&scoped=true", function () {
      api.rerender('932118d8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/dashboard/RevenuePerMonthCompareSettings.vue"
export default component.exports